// @flow

import type {GetCheckedTextList} from '../typedef';

export const getCheckedNestedPathList: GetCheckedTextList = (data, checkedIdsList) => {
    return data.reduce((acc, curr) => {
        const currCaption = curr.caption || '';

        if (checkedIdsList.includes(curr.id)) {
            acc.push(currCaption);
        } else if (curr.children) {
            let childCaption = getCheckedNestedPathList(curr.children, checkedIdsList);

            if (childCaption.length > 0) {
                childCaption = childCaption.map(i => `${currCaption} > ${i}`);
                acc = acc.concat(childCaption);
            }
        }

        return acc;
    }, []);
};
